import * as React from 'react';
import { Balloon,Icon } from '@alifd/next';
import * as AnimateNumber from '@alife/bc-animate-number';
import * as classnames from "classnames"

function TotalPrice ( props: { totalCost: any; i18n: any; quantity: any; moq: any; logistics: any; } ) {
  const { totalCost,i18n,quantity,moq,logistics } = props;
  const { logisticsTime,freightGuaranteeResult = {} } = logistics;

  const { estimateDeliveryDTO,deliveryDTO } = freightGuaranteeResult;

  const renderDelivery = () => {
    // 保障day
    if ( deliveryDTO?.deliveredText ) {
      return (
        <div className="item-align">
          <span
            className={classnames( {
              actived: deliveryDTO?.deliveryTextStyleEnum === 'STRONG',
            } )}
          >
            {deliveryDTO?.guaranteeDeliveryTag}
            <strong>{deliveryDTO?.deliveredLocalDateTextBy}</strong>
          </span>
          {deliveryDTO?.deliverByBenefitDesc && <span className={classnames( {
            actived: deliveryDTO?.deliveryTextStyleEnum === 'STRONG',
          } )}>({deliveryDTO.deliverByBenefitDesc})</span>}
          {deliveryDTO?.deliveredLabel && (
            <label
              className={classnames( {
                actived: deliveryDTO?.deliveryLabelStyleEnum === 'STRONG',
              } )}
            >
              {deliveryDTO?.deliveryTextStyleEnum === 'STRONG'
                ? deliveryDTO?.deliveredLabel
                : `(${deliveryDTO?.deliveredLabel})`}
            </label>
          )}
        </div>
      );
    }
    // 保障date
    if ( estimateDeliveryDTO?.estimateDeliveredText ) {
      return (
        <div className="item-right">
          <span style={{
            marginRight: "4px"
          }}>
            {estimateDeliveryDTO.estimateDeliveryTag}
            <strong>{estimateDeliveryDTO.estimateDeliveredTextBy}</strong>
          </span>
          <Balloon
            trigger={<Icon type="prompt" size="small" />}
            align="br"
            alignEdge
            triggerType="hover"
            closable={false}
            style={{ width: 300 }}
          >
            {i18n['rightAction.shippingTimeTip']}
          </Balloon>
        </div>
      );
    }
    if ( logisticsTime ) {
      return (
        <div className="item-right">
          <span>
            {i18n['rightAction.shippingTime']} <b>{logisticsTime}</b>{' '}
            {i18n['rightAction.shippingTimeDays']} &nbsp;
          </span>
        </div>
      );
    }
    return null;
  };

  return (
    <div
      className={classnames( 'express-item',{
        hide: true,
        show:
          deliveryDTO?.deliveredText ||
          estimateDeliveryDTO?.estimateDeliveredText ||
          logisticsTime ||
          quantity >= moq,
      } )}
    >
      <div
        className={classnames( 'item-left',{
          hide: true,
          show: moq <= quantity,
        } )}
      >
        <span className="strong">{i18n['rightAction.total']}</span>
      </div>
      <div
        className={classnames( 'item-right',{
          hide: true,
          show: moq <= quantity,
        } )}
      >
        {!totalCost === true ? (
          i18n['rightAction.negotiated']
        ) : (
          <span className="price">
            <AnimateNumber value={totalCost} />
          </span>
        )}
      </div>
      {renderDelivery()}
    </div>
  );
}

export default TotalPrice;
